import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { applyTheme, getInitialTheme } from "./hooks/useTheme";
import { aplicarBranding, BRANDING_CACHE_KEY } from "./hooks/useBranding";
import { ConfirmProvider } from "./components/ConfirmProvider";
import { ErrorBoundary } from "./components/ErrorBoundary";
import "./index.css";

// Aplica o tema antes do React montar — evita flash branco/escuro.
applyTheme(getInitialTheme());

// Aplica branding cacheado ANTES do primeiro render. Evita o flash do azul
// padrão antes da request /configuracoes/publico chegar. Se nada estiver
// cacheado, a CSS var default cobre (= Tailwind blue). Quando o request
// retornar, useBranding re-aplica e atualiza o cache.
try {
  const raw = localStorage.getItem(BRANDING_CACHE_KEY);
  if (raw) aplicarBranding(JSON.parse(raw));
} catch {}

// Registra o service worker cedo. Sem isso o navegador não considera o site
// instalável (não dispara "beforeinstallprompt") e o /push-sw.js só seria
// registrado quando o usuário ativasse push manualmente. A chamada é
// idempotente: usePush() chama o mesmo register depois sem efeito colateral.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/push-sw.js", { scope: "/" }).catch((err) => {
      console.warn("[sw] falha ao registrar:", err);
    });
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ConfirmProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ConfirmProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
